import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const ru = {
  "Tab summary": "Сводка",
  "Tab clients": "Клиенты",
  "Tab bot": "Бот",
  "Tab money": "Деньги",
  "Tab more": "Ещё",
  "Become a partner": "Стать партнёром",
  "Hero copy": "Запустите свой VPN-сервис за 10 минут. Мы даём инфраструктуру и платёжки, вы получаете клиентов и наценку.",
  "Bullet 1": "Свой бот с вашим брендом",
  "Bullet 2": "Любая наценка к нашим тарифам",
  "Bullet 3": "Выплаты в крипте и по СБП",
  "Start now": "Начать",
  "Home": "Главная",
  "Dashboard": "Дашборд",
  "Bots": "Боты",
  "Mirrors title": "Свой VPN",
  "Mirrors summary_one": "{{count}} магазин · принесли {{earned}}",
  "Mirrors summary_few": "{{count}} магазина · принесли {{earned}}",
  "Mirrors summary_many": "{{count}} магазинов · принесли {{earned}}",
  "Mirrors empty hint": "Клиенты могут открыть свой магазин, вы получите долю",
  "Subscriptions": "Подписки",
  "Pricing": "Наценки",
  "Manage": "Управление",
  "Finance": "Финансы",
  "Profile": "Профиль",
  "Active subs": "Активные подписки",
  "MRR": "Доход в месяц",
  "Churn 30d": "Отток 30д",
  "Top plans": "Топ-планы",
  "Recent activity": "Последние события",
  "New sub": "Новая подписка",
  "Renew": "Продление",
  "Onb checklist title": "Запустите своего VPN-бота",
  "Onb remaining": "Осталось шагов: {{count}}",
  "Onb checklist bot": "Бот создан",
  "Onb checklist brand": "Брендинг настроен",
  "Onb checklist pricing": "Наценка установлена",
  "Onb checklist first_sale": "Первая продажа",
  "Onb cta create_bot": "Создать",
  "Onb cta brand": "Настроить",
  "Onb cta pricing": "Открыть",
  "Ref QR title": "QR-код реф-ссылки",
  "Ref QR download": "Скачать PNG",
  "Bc field schedule": "Когда отправить",
  "Bc rec_none": "Сразу",
  "Bc rec_once": "По дате",
  "Bc rec_daily": "Каждый день",
  "Bc rec_weekly": "Каждую неделю",
  "Bc rec hint": "«Сразу»: уйдёт сейчас. «По дате»: один раз в выбранный день и время. «Каждый день/неделю»: повторяется. Время московское.",
  "Bc field weekday": "День недели",
  "Wizard 1 title": "Создайте своего бота",
  "Wizard 1 step 1": "Откройте @BotFather в Telegram",
  "Wizard 1 step 2": "Команда /newbot: следуйте инструкциям, придумайте имя и юзернейм",
  "Wizard 1 step 3": "BotFather пришлёт токен вида 123456:ABC…",
  "Wizard 1 step 4": "Вставьте токен сюда: мы проверим и запустим",
  "Bot token": "Bot token",
  "Validate": "Проверить",
  "Token invalid": "Токен не подошёл. Проверьте его в BotFather и вставьте ещё раз.",
  "Token ok": "Токен валиден. Бот: @{{username}}",
  "Open BotFather": "Открыть @BotFather",
  "Next": "Дальше",
  "Wizard 2 title": "Брендинг и наценка",
  "Brand name": "Название сервиса",
  "Brand name hint": "Видно клиенту в боте и WebApp",
  "Currency": "Валюта",
  "Markup percent": "Наценка, %",
  "Markup hint": "Применяется ко всем тарифам. Floor: цена не упадёт ниже себестоимости + комиссии платёжки.",
  "Markup preview": "Превью: {{from}} ₽ → {{to}} ₽",
  "Allowed plans": "Доступные тарифы",
  "Launch bot": "Запустить бота",
  "Bots empty": "У вас пока нет ботов",
  "Bots empty desc": "Создайте первого через мастер.",
  "Create bot": "Создать бота",
  "Subs filter all": "Все",
  "Subs filter active": "Активные",
  "Subs filter expired": "Истёкшие",
  "Subs filter frozen": "Замороженные",
  "Plan": "Тариф",
  "Client": "Клиент",
  "Status": "Статус",
  "Expires": "Истекает",
  "Pricing table title": "Матрица цен",
  "Pricing markup": "Наценка",
  "Pricing base": "Базовая цена",
  "Pricing final": "Цена клиенту",
  "Pricing floor warn": "Ниже минимальной цены: поставим минимальную",
  "Finance balance": "Баланс",
  "Finance withdraw": "Запросить вывод",
  "Finance min withdraw": "Минимум: 100 ₽",
  "Finance withdraw method": "Способ",
  "Finance amount": "Сумма",
  "Finance amount too low": "Сумма меньше минимума",
  "Finance amount too high": "Больше доступного баланса",
  "Finance request sent": "Заявка отправлена. Обычно обрабатываем за сутки.",
  "Tx in": "Поступление",
  "Tx out": "Списание",
  "Tx withdraw": "Вывод",
  "Tx ref": "Реферал",
  "History": "История",
  "Empty subs": "Подписок пока нет",
  "Empty subs desc": "Они появятся, когда ваши клиенты что-нибудь купят.",
  "Language": "Язык",
  "Support": "Поддержка",
  "Tg user fallback": "Пользователь Telegram",
  "Days": "д.",
  "Devices count": "{{count}} устройств",
  "Bot status active": "Активен",
  "Bot status paused": "Пауза",
  "Toggle bot paused": "Бот остановлен",
  "Toggle bot active": "Бот запущен",
  "Copy": "Скопировать",
  "Copied": "Скопировано",
  "Save": "Сохранить",
  "Saved": "Сохранено",
  "Save error": "Не удалось сохранить",
  "Back": "Назад",
  "Confirm": "Подтвердить",
  "Cancel": "Отмена",
  "Referrals": "Рефералы",
  "Marketing": "Маркетинг",
  "Webhooks": "Webhooks",
  "Ref invited": "Приглашено",
  "Ref active": "Активных",
  "Ref earned": "Выплачено клиентам",
  "Ref settings": "Настройка процентов",
  "Ref L1": "1-й уровень",
  "Ref L2": "2-й уровень",
  "Ref link": "Реферальная ссылка",
  "Ref share": "Поделиться",
  "Ref list": "Кто пришёл",
  "Broadcast new": "Новая рассылка",
  "Broadcast title": "Заголовок",
  "Broadcast body": "Текст",
  "Broadcast audience": "Аудитория",
  "Broadcast schedule": "Отложить",
  "Broadcast send now": "Отправить сейчас",
  "Broadcast saved as draft": "Сохранено как черновик",
  "Broadcast queued": "Запланировано",
  "Broadcast sent": "Отправлено {{count}} получателям",
  "Audience all": "Все",
  "Audience active": "Активные",
  "Audience expired": "Истёкшие",
  "Per-plan markup": "Наценка по тарифу",
  "Retry": "Повторить",
  "Webhook details": "Детали события",
  "Marketing empty": "Рассылок ещё не было.",
  "Marketing empty desc": "Создайте первую, и мы отправим её всем вашим клиентам через их ботов.",
  "Bc audience all_clients": "Все клиенты",
  "Bc audience active_clients": "С активной подпиской",
  "Bc audience expired_clients": "Без активной подписки",
  "Bc audience paid_clients": "Платившие",
  "Bc audience unpaid_clients": "Не платившие",
  "Bc audience trial_no_pay": "Триал без оплаты",
  "Bc status sent fmt": "{{sent}} из {{total}} получили",
  "Bc status sent errors": " · {{count}} ошибок",
  "Bc status running fmt": "Идёт отправка… {{sent}} / {{total}}",
  "Bc status queued fmt": "В очереди · {{time}}",
  "Bc status failed": "Не получилось отправить",
  "Bc badge sent": "Отправлено",
  "Bc badge sending": "Отправляем",
  "Bc badge queued": "В очереди",
  "Bc badge failed": "Ошибка",
  "Bc badge cancelled": "Отменена",
  "Bc composer title": "Новая рассылка",
  "Bc field title": "Заголовок",
  "Bc field title placeholder": "Напр.: Новая локация Гонконг",
  "Bc field text": "Текст",
  "Bc field text placeholder": "Текст сообщения. Поддерживается HTML-разметка.",
  "Bc html hint": "Поддерживается HTML: жирный, курсив, ссылки",
  "Bc field audience": "Кому",
  "Bc send": "Отправить",
  "Bc throttle hint": "Сообщение пойдёт через бота, в котором клиент покупал подписку, до 25 сообщений в секунду.",
  "Bc toast queued": "Поставлено в очередь, клиенты получат через минуту",
  "Bc toast failed": "Не отправилось: {{err}}",
  "Copy fallback hint": "Не удалось скопировать. Зажмите ссылку, чтобы выделить её вручную.",
};

const en = {
  "Tab summary": "Summary",
  "Tab clients": "Clients",
  "Tab bot": "Bot",
  "Tab money": "Money",
  "Tab more": "More",
  "Become a partner": "Become a partner",
  "Hero copy": "Launch your own VPN service in 10 minutes. We handle infra and payments — you bring traffic and earn markup.",
  "Bullet 1": "Your own branded bot",
  "Bullet 2": "Any markup on top of our plans",
  "Bullet 3": "Withdraw via crypto or SBP",
  "Start now": "Start",
  "Home": "Home",
  "Dashboard": "Dashboard",
  "Bots": "Bots",
  "Mirrors title": "Your own VPN",
  "Mirrors summary_one": "{{count}} store · earned you {{earned}}",
  "Mirrors summary_other": "{{count}} stores · earned you {{earned}}",
  "Mirrors empty hint": "Clients can open their own store, you get a share",
  "Subscriptions": "Subscriptions",
  "Pricing": "Pricing",
  "Manage": "Manage",
  "Finance": "Finance",
  "Profile": "Profile",
  "Active subs": "Active subs",
  "MRR": "Monthly income",
  "Churn 30d": "Churn 30d",
  "Top plans": "Top plans",
  "Recent activity": "Recent activity",
  "New sub": "New sub",
  "Renew": "Renew",
  "Onb checklist title": "Launch your VPN bot",
  "Onb remaining": "Steps left: {{count}}",
  "Onb checklist bot": "Bot created",
  "Onb checklist brand": "Branding set up",
  "Onb checklist pricing": "Markup configured",
  "Onb checklist first_sale": "First sale",
  "Onb cta create_bot": "Create",
  "Onb cta brand": "Configure",
  "Onb cta pricing": "Open",
  "Ref QR title": "Referral link QR",
  "Ref QR download": "Download PNG",
  "Bc field schedule": "When to send",
  "Bc rec_none": "Now",
  "Bc rec_once": "On date",
  "Bc rec_daily": "Every day",
  "Bc rec_weekly": "Every week",
  "Bc rec hint": "“Now” sends immediately. “On date” — once at a chosen day and time. “Every day/week” repeats. Times are Moscow time.",
  "Bc field weekday": "Weekday",
  "Wizard 1 title": "Create your bot",
  "Wizard 1 step 1": "Open @BotFather in Telegram",
  "Wizard 1 step 2": "Use /newbot — follow instructions, pick name and username",
  "Wizard 1 step 3": "BotFather will send you a token like 123456:ABC…",
  "Wizard 1 step 4": "Paste the token below and we'll validate it",
  "Bot token": "Bot token",
  "Validate": "Validate",
  "Token invalid": "Invalid token. Check and try again.",
  "Token ok": "Token is valid. Bot: @{{username}}",
  "Open BotFather": "Open @BotFather",
  "Next": "Next",
  "Wizard 2 title": "Branding and markup",
  "Brand name": "Brand name",
  "Brand name hint": "Visible to clients in bot and WebApp",
  "Currency": "Currency",
  "Markup percent": "Markup, %",
  "Markup hint": "Applied to all plans. Floor: price won't drop below cost + payment fees.",
  "Markup preview": "Preview: {{from}} ₽ → {{to}} ₽",
  "Allowed plans": "Allowed plans",
  "Launch bot": "Launch bot",
  "Bots empty": "No bots yet",
  "Bots empty desc": "Create one via the wizard.",
  "Create bot": "Create bot",
  "Subs filter all": "All",
  "Subs filter active": "Active",
  "Subs filter expired": "Expired",
  "Subs filter frozen": "Frozen",
  "Plan": "Plan",
  "Client": "Client",
  "Status": "Status",
  "Expires": "Expires",
  "Pricing table title": "Pricing matrix",
  "Pricing markup": "Markup",
  "Pricing base": "Base price",
  "Pricing final": "Client price",
  "Pricing floor warn": "Below floor — will be clamped",
  "Finance balance": "Balance",
  "Finance withdraw": "Request withdraw",
  "Finance min withdraw": "Minimum: 100 ₽",
  "Finance withdraw method": "Method",
  "Finance amount": "Amount",
  "Finance amount too low": "Below minimum",
  "Finance amount too high": "More than available",
  "Finance request sent": "Request sent. Usually within 24 hours.",
  "Tx in": "Incoming",
  "Tx out": "Outgoing",
  "Tx withdraw": "Withdraw",
  "Tx ref": "Referral",
  "History": "History",
  "Empty subs": "No subscriptions yet",
  "Empty subs desc": "They'll appear once your clients buy something.",
  "Language": "Language",
  "Support": "Support",
  "Tg user fallback": "Telegram user",
  "Days": "d",
  "Devices count": "{{count}} devices",
  "Bot status active": "Active",
  "Bot status paused": "Paused",
  "Toggle bot paused": "Bot paused",
  "Toggle bot active": "Bot active",
  "Copy": "Copy",
  "Copied": "Copied",
  "Save": "Save",
  "Saved": "Saved",
  "Save error": "Failed to save",
  "Back": "Back",
  "Confirm": "Confirm",
  "Cancel": "Cancel",
  "Referrals": "Referrals",
  "Marketing": "Marketing",
  "Webhooks": "Webhooks",
  "Ref invited": "Invited",
  "Ref active": "Active",
  "Ref earned": "Paid to clients",
  "Ref settings": "Percent settings",
  "Ref L1": "Level 1",
  "Ref L2": "Level 2",
  "Ref link": "Referral link",
  "Ref share": "Share",
  "Ref list": "Who joined",
  "Broadcast new": "New broadcast",
  "Broadcast title": "Title",
  "Broadcast body": "Body",
  "Broadcast audience": "Audience",
  "Broadcast schedule": "Schedule",
  "Broadcast send now": "Send now",
  "Broadcast saved as draft": "Saved as draft",
  "Broadcast queued": "Scheduled",
  "Broadcast sent": "Sent to {{count}} users",
  "Audience all": "All",
  "Audience active": "Active",
  "Audience expired": "Expired",
  "Per-plan markup": "Per-plan markup",
  "Retry": "Retry",
  "Webhook details": "Event details",
  "Marketing empty": "No broadcasts yet.",
  "Marketing empty desc": "Create your first one — we'll send it to all your clients via their bots.",
  "Bc audience all_clients": "All clients",
  "Bc audience active_clients": "With active subscription",
  "Bc audience expired_clients": "Without active subscription",
  "Bc audience paid_clients": "Paying clients",
  "Bc audience unpaid_clients": "Never paid",
  "Bc audience trial_no_pay": "Trial, no payment",
  "Bc status sent fmt": "{{sent}} of {{total}} delivered",
  "Bc status sent errors": " · {{count}} errors",
  "Bc status running fmt": "Sending… {{sent}} / {{total}}",
  "Bc status queued fmt": "Queued · {{time}}",
  "Bc status failed": "Failed to send",
  "Bc badge sent": "Sent",
  "Bc badge sending": "Sending",
  "Bc badge queued": "Queued",
  "Bc badge failed": "Failed",
  "Bc badge cancelled": "Cancelled",
  "Bc composer title": "New broadcast",
  "Bc field title": "Title",
  "Bc field title placeholder": "e.g. New Hong Kong location",
  "Bc field text": "Body",
  "Bc field text placeholder": "Message text. HTML markup supported.",
  "Bc html hint": "HTML supported: bold, italic, links",
  "Bc field audience": "Audience",
  "Bc send": "Send",
  "Bc throttle hint": "Sent via the bot where the client originally purchased. Throttle 25 msg/s.",
  "Bc toast queued": "Queued — clients will receive it within a minute",
  "Bc toast failed": "Failed to send: {{err}}",
  "Copy fallback hint": "Couldn't copy. Long-press the link to select manually.",
};

i18n.use(initReactI18next).init({
  resources: { ru: { translation: ru }, en: { translation: en } },
  lng: 'ru',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
